<form class="filter table-filter" [formGroup]="searchForm">
  <mat-form-field class="form" subscriptSizing="dynamic">
    <mat-chip-grid #assistChips>
      @for (assist of activeAssists$ | async; track assist) {
        <mat-chip-row (removed)="onRemoveAssist(assist.id)">
          {{ assist.description }}
          <button matChipRemove>
            <app-icon icon="delete"></app-icon>
          </button>
        </mat-chip-row>
      }
      <input matInput class="form"
        i18n-placeholder
        placeholder="Type here to filter packages..."
        [matChipInputFor]="assistChips"
        [matAutocomplete]="filterAssist"
        type="text" formControlName="terms"
        #termsInput
        >
    </mat-chip-grid>
    <mat-autocomplete #filterAssist (optionSelected)="onAssistSelection($event.option.value)">
      @for (assist of offeredAssists$ | async; track assist) {
        <mat-option [value]="assist">
          {{ assist.description }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
